import styled, {css} from 'styled-components'
import {Flexbox} from '@/components/ui/flexbox/FlexBox'

export const StyledEmptyConversationStateContainer = styled(Flexbox)(
    ({theme: {spacing}}) => css`
        height: 100%;
        padding: ${spacing * 4}px;
    `
)

export const StyledEmptyConversationStateIcon = styled.div(
    ({theme: {palette, spacing}}) => css`
        color: ${palette.neutral[300]};
        margin-bottom: ${spacing * 3}px;
        display: flex;
        align-items: center;
        justify-content: center;
    `
)
